import LocalRunner from "./LocalRunner";

export default LocalRunner;